export const FETCH_PRIVATE_CHAT_REQUEST = "FETCH_PRIVATE_CHAT_REQUEST";
export const SET_PRIVATE_CHAT_SUCCESS = "SET_PRIVATE_CHAT_SUCCESS";
export const SET_ALL_PRIVATE_CHAT_SUCCESS = "SET_ALL_PRIVATE_CHAT_SUCCESS";
export const SET_PRIVATE_CHAT_FAILURE = "SET_PRIVATE_CHAT_FAILURE";
export const SET_CHAT_ROOM_ID = "SET_CHAT_ROOM_ID";
